import React from 'react'

const SOWStatusNotifier = () => {
    
  return (
    <div>SOWStatusNotifier</div>
  )
}

export default SOWStatusNotifier